import React from 'react';
import { ActionMenuActions } from './ActionDropdownMenu';
import './ActionDropdownMenu.scss';
import { useTranslation } from 'react-i18next';

interface ActionMenuItemProps {
  action: ActionMenuActions;
  disabled?: boolean;
  onClickHandler: (e: any) => void;
}

interface ActionPropData {
  icon: string;
  textKey: string;
}
export function ActionMenuItem(props: ActionMenuItemProps) {
  const actionProps: { [key in ActionMenuActions]: ActionPropData } = {
    [ActionMenuActions.SubmitForReview]: {
      icon: 'far fa-share-square',
      textKey: 'productActions.dropdown.menu.submitForReview',
    },
    [ActionMenuActions.SubmitForImport]: {
      icon: 'far fa-check',
      textKey: 'productActions.dropdown.menu.submitForImport',
    },
    [ActionMenuActions.Reject]: {
      icon: 'far fa-ban',
      textKey: 'productActions.button.reject',
    },
    [ActionMenuActions.ReturnToDraft]: {
      icon: 'far fa-undo-alt',
      textKey: 'productActions.dropdown.menu.returnToDraft',
    },
    [ActionMenuActions.ReturnToReview]: {
      icon: 'far fa-undo-alt',
      textKey: 'productActions.dropdown.menu.returnToUnderReview',
    },
    [ActionMenuActions.DuplicateProduct]: {
      icon: 'far fa-clone',
      textKey: 'productActions.dropdown.menu.duplicateProduct',
    },
    [ActionMenuActions.DeleteDraft]: {
      icon: 'far fa-times',
      textKey: 'productActions.dropdown.menu.deleteDraft',
    },
    [ActionMenuActions.AddToProject]: {
      icon: 'far fa-plus',
      textKey: 'productActions.dropdown.menu.addToProject',
    },
    [ActionMenuActions.RemoveFromProject]: {
      icon: 'far fa-times',
      textKey: 'productActions.dropdown.menu.removeFromProject',
    },
    [ActionMenuActions.DuplicateForDigital]: {
      icon: 'far fa-copy',
      textKey: 'productActions.dropdown.menu.duplicateForDigital',
    },
    [ActionMenuActions.EditProduct]: {
      icon: 'far fa-edit',
      textKey: 'productActions.dropdown.menu.editProduct',
    },
    [ActionMenuActions.RequestChange]: {
      icon: 'far fa-plus',
      textKey: 'product.changeRequest.requestChange',
    },
    [ActionMenuActions.ChangePending]: {
      icon: 'far fa-edit',
      textKey: 'product.changeRequest.changePending',
    },
    [ActionMenuActions.SubmitChangeRequest]: {
      icon: 'far fa-check',
      textKey: 'productActions.dropdown.menu.submitChangeRequest',
    },
    [ActionMenuActions.DeleteChangeRequest]: {
      icon: 'far fa-times',
      textKey: 'product.changeRequest.deleteRequest',
    },
  };

  const { t } = useTranslation();

  return (
    <li className={props.disabled ? 'disabled' : ''} role="none">
      <button
        type="button"
        role="menuitem"
        className="dropdown-item"
        disabled={props.disabled}
        onClick={props.onClickHandler}
      >
        <i
          className={actionProps[props.action].icon + ' action-dropdown-icon'}
        ></i>
        <span className="action-item-label">
          {t(actionProps[props.action].textKey)}
        </span>
      </button>
    </li>
  );
}
